import {
  FILE_DOWNLOAD_ALL_FAIL,
  FILE_DOWNLOAD_ALL_REQUEST,
  FILE_DOWNLOAD_ALL_RESET,
  FILE_DOWNLOAD_ALL_SUCCESS,
  FILE_DOWNLOAD_FAIL,
  FILE_DOWNLOAD_REQUEST,
  FILE_DOWNLOAD_RESET,
  FILE_DOWNLOAD_SUCCESS,
} from '../constants/fileConstants'

export const fileDownloadReducer = (state = {}, action) => {
  switch (action.type) {
    case FILE_DOWNLOAD_REQUEST:
      return { loading: true, fileName: action.payload }
    case FILE_DOWNLOAD_SUCCESS:
      return { ...state, loading: false, success: true, file: action.payload }
    case FILE_DOWNLOAD_FAIL:
      return { loading: false, error: action.payload }
    case FILE_DOWNLOAD_RESET:
      return {}
    default:
      return state
  }
}

export const fileDownloadAllReducer = (state = {}, action) => {
  switch (action.type) {
    case FILE_DOWNLOAD_ALL_REQUEST:
      return { loading: true }
    case FILE_DOWNLOAD_ALL_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        fileName: 'download.zip',
        file: action.payload,
      }
    case FILE_DOWNLOAD_ALL_FAIL:
      return { loading: false, error: action.payload }
    case FILE_DOWNLOAD_ALL_RESET:
      return {}
    default:
      return state
  }
}
